import { explicitMaybe } from '@execonline-inc/decoders';
import { Decoder, boolean, dateISO, field, number, string, succeed } from 'jsonous';
import { resourceDecoder } from '../../../../../../../../../../../Resource/Decoders';
import {
  ParticipantsInvitedResource,
  ParticipantsInvitedSuccessfully,
  ProductLicenseInformation,
  ProductLicenseInformationResource,
} from './Types';

export const participantsInvitedDecoder: Decoder<ParticipantsInvitedSuccessfully> = succeed({})
  .assign('sendEmailDate', field('send_email_date', dateISO))
  .assign('successfulCommunicationsCount', field('successful_communications_count', number))
  .assign('skipCommunications', field('skip_communications', boolean));

export const participantsInvitedResourceDecoder: Decoder<ParticipantsInvitedResource> =
  resourceDecoder(participantsInvitedDecoder);

export const productLicenseInformationDecoder: Decoder<ProductLicenseInformation> = succeed({})
  .assign('publicName', field('public_name', string))
  .assign('allocatedLicenses', field('allocated_licenses', number))
  .assign('activationsRemaining', field('activations_remaining', explicitMaybe(number)))
  .assign('alreadyActiveLicenses', field('already_active_licenses', number))
  .assign('newLicenseAllocations', field('new_license_allocations', number))
  .assign('potentialLicenseActivations', field('potential_license_activations', number))
  .assign('daysUntilRenewal', field('days_until_renewal', number));

export const productLicenseInformationResourceDecoder: Decoder<ProductLicenseInformationResource> =
  resourceDecoder(productLicenseInformationDecoder);
